/*eslint-disable*/
export default {
    install(Vue) {
        Vue.prototype.$offline = env.offline;
        Vue.prototype.$pointsSystem = env.points;
        Vue.prototype.$appEnv = env.appEnv;
        Vue.prototype.$scoring = env.scoring;
        Vue.prototype.$apiEndpoint = api.env.API_ENDPOINT;
        Vue.prototype.$lastMapAvailableLocation = env.lastMapAvailableLocation;
        Vue.prototype.$isMapAvailable = env.isMapAvailable;
        Vue.prototype.$isDetectiveAvailable = env.isDetectiveAvailable;
    }
}
